import { Component, Input, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { CommonModule } from '@angular/common';
import { ShopSelectionStore } from '../../../core/state/shop-selection.store';
import { ShopSelectionService } from '../../../core/services/shop-selection/shop-selection.service';
import { Resident } from '../../models/resident.model';
import { ResidentSubHeaderComponent } from './resident-sub-header/resident-sub-header.component';
import { PageSubHeaderComponent } from './page-sub-header/page-sub-header.component';
import { ResidentSelectorComponent } from './resident-selector/resident-selector.component';
import { HeaderMenuComponent } from '../header-menu/header-menu.component';
import { LogoHeaderComponent } from '../logo-header/logo-header.component';

@Component({
  selector: 'app-web-header',
  templateUrl: './web-header.component.html',
  styleUrls: ['./web-header.component.scss'],
  imports: [
    CommonModule,
    ResidentSubHeaderComponent,
    PageSubHeaderComponent,
    ResidentSelectorComponent,
    HeaderMenuComponent,
    LogoHeaderComponent,
  ],
})
export class WebHeaderComponent {
  private readonly store = inject(ShopSelectionStore);
  private readonly shopSelectionService = inject(ShopSelectionService);

  @Input() shopHeader: boolean = false;
  @Input() pageHeader: boolean = false;
  @Input() noShadow: boolean = false;

  readonly customer = toSignal(this.store.customer$, { initialValue: null });
  readonly department = toSignal(this.store.department$, {
    initialValue: null,
  });
  readonly resident = toSignal(this.store.resident$, { initialValue: null });
  readonly isFirstLogin = toSignal(this.store.isFirstLogin$, {
    initialValue: false,
  });

  menuOpen: boolean = false;
  isBackdropVisible: boolean = false;

  residentChanged(resident: Resident): void {
    this.shopSelectionService.selectResident(resident.id);
  }
}
